import { render, staticRenderFns } from "./TabBarItem.vue?vue&type=template&id=99930660&scoped=true&"
import script from "./TabBarItem.vue?vue&type=script&lang=js&"
export * from "./TabBarItem.vue?vue&type=script&lang=js&"
import style0 from "./TabBarItem.vue?vue&type=style&index=0&id=99930660&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99930660",
  null
  
)

export default component.exports